export const aboutContent = {
  brandName: `爱妻艺`,
  tagline: `让爱有艺术，让妻子更幸福`,
  introduction: `爱妻艺是一个专注于夫妻关系经营的内容平台。我们相信，幸福的婚姻不是偶然的运气，而是可以学习的艺术。无论是浪漫仪式感、沟通技巧还是日常关爱，爱妻艺为您提供最实用的婚姻幸福指南，帮助每一位丈夫成为妻子心中最好的伴侣。`,
  mission: `我们的使命是帮助一千万个中国家庭建立更幸福、更和谐的夫妻关系。通过科学的方法、真实的故事和可操作的指南，让每一个丈夫都能掌握"爱妻"的艺术，让每一位妻子都能在婚姻中感受到被珍视的幸福。`,
  story: `爱妻艺的创立源于一个简单的观察：很多丈夫深爱着自己的妻子，却不知道如何表达。他们想要让妻子幸福，却缺乏有效的方法和指导。市面上充斥着各种两性关系的内容，但很少有专门针对丈夫视角、以"如何让妻子更幸福"为核心主题的优质内容。于是，爱妻艺应运而生。我们汇聚了心理学家、婚姻咨询师和众多幸福丈夫的真实经验，打造了这个专注于提升丈夫"爱妻力"的内容平台。`,
  values: [
    {
      title: `真诚真挚`,
      description: `我们相信最好的婚姻建议来自真实的生活经验，每一个分享都经过实践验证。`
    },
    {
      title: `科学务实`,
      description: `我们结合心理学研究成果与真实案例，提供科学有效的婚姻经营方法。`
    },
    {
      title: `持续成长`,
      description: `我们倡导婚姻是终身学习的过程，鼓励每一位丈夫持续提升自己。`
    },
    {
      title: `尊重平等`,
      description: `我们强调夫妻关系中的相互尊重，倡导平等健康的伴侣关系。`
    }
  ],
  testimonials: [
    {
      name: `张先生`,
      marriageYears: `结婚8年`,
      content: `自从按照爱妻艺的建议建立了每周约会日传统后，我和妻子的关系明显改善了。那些小仪式感真的让我们的婚姻重新充满了期待和惊喜。`
    },
    {
      name: `李先生`,
      marriageYears: `结婚5年`,
      content: `以前总觉得已经结婚了就不用刻意表达了，看了爱妻艺的文章才知道，妻子需要的正是那些'刻意'的关心。现在每天都会给她发一条温暖的信息，她说这让她整天都很开心。`
    },
    {
      name: `王先生`,
      marriageYears: `结婚12年`,
      content: `结婚十几年了，以为已经很了解妻子了。爱妻艺的沟通技巧文章让我意识到，倾听比表达更重要。现在我学会在妻子说话时真正地听，我们的关系比刚结婚时还好。`
    },
    {
      name: `陈先生`,
      marriageYears: `结婚3年`,
      content: `作为新婚丈夫，爱妻艺给了我很大的帮助。那些生活细节关爱的建议特别实用，让我从一开始就建立了让妻子幸福的习惯。感谢爱妻艺！`
    }
  ],
  contact: {
    email: `hello@mhowiub.cn`,
    wechat: `爱妻艺官方`,
    address: `北京市朝阳区建国路88号`,
    phone: `010-8888-6666`
  }
};